'use strict';

module.exports = [
	{
		name: 'SHEEP_CITY',
		url: '256584518'
	},
	{
		name: 'HIGH_NOON_SALOON',
		url: '255913180'
	},
	{
		name: 'BLOCKY_RACES',
		url: '255921336'
	},
	{
		name: 'SPARTAN_SCHOOL',
		url: '255936121'
	},
	{
		name: 'SIMPLE_LUCKY_BLOCKS',
		url: '256761532'
	},
	{
		name: 'HEIST_AND_SEEK',
		url: '256769536'
	},
	{
		name: 'SPLEEF',
		url: '256825917'
	},
	{
		name: 'FLAPPY_BLOCK',
		url: '258048185'
	},
	{
		name: 'THE_WALLS',
		url: '258053834'
	},
	{
		name: 'EGG_WARS',
		url: '256913484'
	},
	{
		name: 'HUNGRY_GAMES',
		url: '256982852'
	},
	{
		name: 'LUCKY_BLOCKS',
		url: '256927849'
	},
	{
		name: 'RISE_OF_THE_WEREBUNNIES',
		url: '257092825'
	},
	{
		name: 'HORROR',
		url: '258226333'
	},
	{
		name: 'DANCE_TO_THE_MOOSIC',
		url: '258788926'
	},
	{
		name: 'SWOOP_DE_LOOP',
		url: '258992003'
	},
	{
		name: 'THE_GREAT_BLOCKISH_BAKE_OFF',
		url: '259660296'
	},
	{
		name: 'BUILDING',
		url: '260055451'
	},
	{
		name: 'EPIC_MODS',
		url: '258230386'
	},
	{
		name: 'AVENGERS',
		url: '260792120'
	},
	{
		name: 'BOUNCING_AROUND',
		url: '260911248'
	},
	{
		name: 'BOWING_N_GLOWING',
		url: '260917362'
	},
	{
		name: 'DANCE_TO_THE_TWOOSIC',
		url: '260984111'
	},
	{
		name: 'NO_PLACE_LIKE_HOME',
		url: '260987743'
	},
	{
		name: 'CONSTRUCTION_COLLECTION',
		url: '261102381'
	},
	{
		name: 'PIRATES',
		url: '261096038'
	},
	{
		name: 'ONE_IN_THE_CHAMBER',
		url: '261104388'
	},
	{
		name: 'PLAYER_V_PLAYER',
		url: '261129195'
	},
	{
		name: 'WELCOME_TO_THE_MOB',
		url: '261118193'
	},
	{
		name: 'MOB_MADNESS',
		url: '261158405'
	},
	{
		name: 'SERVER_MANIA',
		url: '261148245'
	},
	{
		name: 'PARKOUR',
		url: '261299410'
	},
	{
		name: 'WIZARD_WONDER',
		url: '261290090'
	},
	{
		name: 'TROLLING_1',
		url: '261313844'
	},
	{
		name: 'TROLLING_2',
		url: '261337648'
	},
	{
		name: 'RAVINE_RUNNER',
		url: '261352201'
	},
	{
		name: 'EGG_WARS_TRAILER',
		url: '256917177'
	},
	{
		name: 'HIGH_NOON_SALOON_TRAILER',
		url: '256918343'
	},
	{
		name: 'RISE_OF_THE_WEREBUNNIES_TRAILER',
		url: '256922630'
	},
	{
		name: 'HUNGRY_GAMES_TRAILER',
		url: '256921720'
	},
	{
		name: 'LUCKY_BLOCKS_TRAILER',
		url: '256920395'
	},
	{
		name: 'SIMPLE_LUCKY_BLOCKS_TRAILER',
		url: '256919635'
	},
	{
		name: 'BLOCKY_RACES_TRAILER',
		url: '256917469'
	},
	{
		name: 'SPLEEF_TRAILER',
		url: '256917268'
	},
	{
		name: 'HEIST_AND_SEEK_TRAILER',
		url: '256763274'
	},
	{
		name: 'HORROR_TRAILER',
		url: '258230261'
	},
	{
		name: 'SWOOP_DE_LOOP_TRAILER',
		url: '258997571'
	},
	{
		name: 'DANCE_TO_THE_MOOSIC_TRAILER',
		url: '258804857'
	},
	{
		name: 'THE_GREAT_BLOCKISH_BAKE_OFF_TRAILER',
		url: '259875012'
	},
	{
		name: 'BUILDING_TRAILER',
		url: '260220030'
	},
	{
		name: 'EPIC_MODS_TRAILER',
		url: '258233967'
	}
];
